// ABOUTME: The labels of the bulk change action kinds, shared by the action cards, the rows table and the filters.
// ABOUTME: Declared once with defineMessages so the label extraction sees every id.

import { defineMessages } from 'react-intl';

export const actionKindMessages = defineMessages({
    setValue: { id: 'bulkChange.action.setValue', defaultMessage: 'Set value' },
    clearValue: { id: 'bulkChange.action.clearValue', defaultMessage: 'Clear value' },
    copyValue: { id: 'bulkChange.action.copyValue', defaultMessage: 'Copy value' },
    replaceText: { id: 'bulkChange.action.replaceText', defaultMessage: 'Replace text' },
    addLinks: { id: 'bulkChange.action.addLinks', defaultMessage: 'Add links' },
    removeLinks: { id: 'bulkChange.action.removeLinks', defaultMessage: 'Remove links' },
    replaceLink: { id: 'bulkChange.action.replaceLink', defaultMessage: 'Replace link' },
    translate: { id: 'bulkChange.action.translate', defaultMessage: 'Translate with AI' },
    deleteNode: { id: 'bulkChange.action.deleteNode', defaultMessage: 'Delete objects' },
});
